import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { ProfileService } from '../../services/profile/profile.service';
import { MetaService } from '../../services/meta/meta.service';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
  public content: Entry<any> | undefined;
  public hasSubscription: boolean | undefined;

  constructor(
    activatedRoute: ActivatedRoute,
    profileService: ProfileService,
    meta: MetaService
  ) {
    this.content = activatedRoute.snapshot.data.content;
    if (this.content && this.content.fields.seo) {
      meta.updateMetaTags(this.content.fields.seo);
    }

    profileService.userActiveSubscriptions().subscribe(subs => {
      this.hasSubscription = !!subs && subs.length > 0;
    });
  }

  ngOnInit() {}
}
